var CardInstitutionalList = function () {

	this.init = function () {

		$(window).on('load resize', function () {
			cardEqualize();
			if ($(window).width() < 481) {
				slider();
			} else {
				$('[data-component="card-institutional-list"].slider .slick-initialized').slick('unslick');
			}
		})

		function cardEqualize() {
			$("[data-component='card-institutional-list']").each(function () {
				var maxHeight = 0;
				var cards = $(this).find(".card-column [data-component='card-institutional']");

				cards.each(function () {
					$(this).css('height', 'auto');
					if ($(this).height() > maxHeight) {
						maxHeight = $(this).height();
					}
				})
				cards.height(maxHeight);

				if (window.innerWidth <= 767) {
					cards.css('height', 'auto');
				}
			})
		}

		function slider() {
			$('[data-component="card-institutional-list"].slider .cards-row').each(function() {
				if ($(this).children().length > 1) {
					$(this).slick({
						dots: true,
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						arrows: false,
						autoplay: false,
						autoplaySpeed: 4000
					});
				}
			})
		}
	}

	return this.init();
}
